export default __webpack_public_path__ + "static/media/bg.74350563.png";